export default __webpack_public_path__ + "static/media/015-frog prince.321a38e2.svg";